(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDashboardDialogController', TabObjectsDashboardDialogController);

    TabObjectsDashboardDialogController.$inject = [ '$scope', 'entity', 'TabObjects', '$state', 'Geolocalization', 'TabObjectsConditions'];

    function TabObjectsDashboardDialogController( $scope, entity, TabObjects, $state, Geolocalization, TabObjectsConditions) {

        var vm = this;
        vm.tabObjects = entity;
        vm.timeZone = [];

        //wait for tabObjects before loading gmap
        vm.tabObjects.$promise.then(function () {
            if(vm.tabObjects.condition.name === "in production") {
                vm.tabObjectsConditions = TabObjectsConditions.checkTest({id: vm.tabObjects.id});
            } else {
                vm.tabObjectsConditions = TabObjectsConditions.query();
            }
            Geolocalization.initializeGoogleMap(vm.tabObjects,$scope);
            var timeZoneSelected = {timeZone: vm.tabObjects.objectTimeZone};
            vm.tabObjects.timeZone = timeZoneSelected;
        });

        vm.onChangeCoordsFunction = function() {
            Geolocalization.reverseGeocode(vm.tabObjects,$scope);
        };

        vm.onChangeAddressFunction = function() {
            Geolocalization.geocodeFromAddress(vm.tabObjects,$scope);
        };

        vm.loadAllTimeZone = function() {
            TabObjects.timeZones(onZoneSuccess, onZoneError);

            function onZoneSuccess(data){
                vm.timeZone = [];
                for (var i = 0; i < data.length; i++) {
                    var timeZ = {timeZone: data[i]};
                    vm.timeZone.push(timeZ);
                }
            }

            function onZoneError(){}
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectsUpdate', result);
            vm.isSaving = false;
            $state.go('tab-objects-dashboard');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            var timeZ = vm.tabObjects.timeZone;
            vm.tabObjects.objectTimeZone = timeZ.timeZone;
            if (vm.tabObjects.id !== null) {
                TabObjects.updateMetadata(vm.tabObjects, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-objects-dashboard',{
                firstAccess: false
            }, {notify: true, location: "replace"});
        };

        vm.onChangeCoordsFunction = function() {
            Geolocalization.reverseGeocode(vm.tabObjects, $scope);
        };

        vm.onChangeAddressFunction = function() {
            Geolocalization.geocodeFromAddress(vm.tabObjects, $scope);
        };

        vm.loadAllTimeZone();
    }
})();
